import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';


const Manual = () => (
    <Fragment>
        <Helmet><title>Eduraw</title></Helmet>
        <div id="home">
            
            <section className='main-home'>
               
                <div>
                    <br/>

                <h1>How to play</h1>
               
               <p>Teams through captain choose one of 10 themes for their element and count of points, which could be 100,300 or 500.</p>
               <br />
               <p>Then question will be show, and students have 1 minute to answer it. They have to choose Yes or No. After right answer points are added, after bad answer they are count down and video with explanation of question ran.</p>
               <br />
               <p>When all questions are answered, team which have more points win.</p>
                </div>

                
            </section> 

            
        </div>  
      

    </Fragment>
    
);

export default Manual;
